<template>
  <div id="projects" class="v2-projects" tabindex="-1">
    <div class="v2-projects__title">Projects</div>
    <div class="v2-container v2-projects__container">
      <div class="v2-projects__left">
        <V2BgMotion />

        <div class="v2-projects__title v2-projects__title--md">
          Projects
        </div>
        <div class="v2-projects-info">
          <div class="d-flex align-items-center v2-projects-info__title-wrap">
            <a
              :href="activeProject.link || 'javascript:void(0)'"
              class="v2-projects-info__title"
              :target="activeProject.link && '_blank'"
              >{{ activeProject.name }}</a
            >
            <div class="v2-projects-info__title-line"></div>
            <div class="v2-projects-info__year">{{ activeProject.year }}</div>
          </div>
          <div class="v2-projects-info__descr">
            {{ activeProject.descr }}
          </div>
        </div>
      </div>
      <div class="v2-projects__right">
        <div class="v2-projects__wrap">
          <div class="v2-projects-slider__wrap">
            <a
              class="v2-projects-slider"
              href="javascript:void(0)"
              target="_blank"
              rel="noopener nofollow"
            >
              <img
                v-for="(project, i) in projects"
                :key="i"
                :src="project.img"
                alt=""
                :data-link="project.link || $router.currentRoute.path"
              />
            </a>
          </div>
          <div class="v2-projects-slider__nav">
            <button
              class="v2-projects-slider__nav-btn v2-projects-slider__nav-btn--prev"
              type="btn"
            ></button>
            <div class="v2-projects-slider__nav-counter">
              {{ activeProjectIndex + 1 }}
              &nbsp;/&nbsp;
              {{ projects.length }}
            </div>
            <button
              class="v2-projects-slider__nav-btn v2-projects-slider__nav-btn--next"
              type="btn"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import gsap from "gsap-3";

import distortionSlider from "@/utils/distortionSlider.js";
import {
  handleTouchStart,
  handleTouchMove,
  handleTouchEnd,
} from "@/utils/swipe.js";

import V2BgMotion from "@/components/v2/V2BgMotion";

export default {
  name: "V2Projects",
  components: { V2BgMotion },
  data() {
    return {
      projects: [
        {
          name: "GO AND GUIDE 360",
          link: "https://goguide.ru/",
          img: require("@/assets/img/projects/go-and-guide.jpg"),
          year: "2022",
          descr:
            "Website layout, front-end development based on SPA with Vue.js",
        },
        {
          name: "Parkomat",
          link: "",
          img: require("@/assets/img/projects/parkomat.jpg"),
          year: "2022",
          descr:
            "Website layout, front-end development based on SPA with Vue.js",
        },
        {
          name: "Next Eco Energy",
          link: "https://nextecoenergy.kz/",
          img: require("@/assets/img/projects/nextecoenergy.jpg"),
          year: "2021",
          descr:
            "Website layout, front-end development based on SPA with Vue3.js",
        },
        {
          name: "RNA Energy",
          link: "https://rnaenergy.kz/",
          img: require("@/assets/img/projects/rna.jpg"),
          year: "2021",
          descr:
            "Website layout, front-end development based on SPA with Vue.js",
        },
        {
          name: "VAN Energy",
          link: "https://vanenergy.kz/",
          img: require("@/assets/img/projects/van.jpg"),
          year: "2021",
          descr:
            "Website layout, front-end development based on SPA with Vue.js",
        },
        {
          name: "Spectechnika.RU",
          link: "https://spb.spectechnika.ru/",
          img: require("@/assets/img/projects/spectechnika.jpg"),
          year: "2020",
          descr: "Website layout",
        },
        {
          name: "Мегаполис.Автошкола",
          link: "https://megapolis-car.ru/",
          img: require("@/assets/img/projects/mcar.jpg"),
          year: "2020",
          descr: "Website back-end & admin panel development",
        },
        {
          name: "Tourbox.Pro",
          link: "https://tourbox.pro/",
          img: require("@/assets/img/projects/tourbox.jpg"),
          year: "2020",
          descr: "Website front-end, back-end & admin panel development",
        },
        {
          name: "goldnet.market",
          link: "https://goldnet.market/",
          img: require("@/assets/img/projects/goldnet.jpg"),
          year: "2020",
          descr:
            "Website layout, front-end, back-end & admin panel development",
        },
        {
          name: "Accord Pitch Doha",
          link: "http://apd.qa/",
          img: require("@/assets/img/projects/apd.jpg"),
          year: "2020",
          descr: "Website back-end development",
        },
        {
          name: "GetRussianVisa",
          link: "https://getrussianvisa.com/en/visa-invitation",
          img: require("@/assets/img/projects/grv.jpg"),
          year: "2019",
          descr: "Visa invitation widget development",
        },
        {
          name: "Kaspi Insurance",
          link: "",
          img: require("@/assets/img/projects/1-kaspi.jpg"),
          year: "2019",
          descr:
            "Layout and front-end of the site based on Nuxt.js, development of functionality for online ordering of insurance",
        },
        {
          name: "Esentai Gourmet",
          link: "https://esentai-gourmet.kz/catering/",
          img: require("@/assets/img/projects/2-esentai.jpg"),
          year: "2018",
          descr: "Website layout",
        },
        {
          name: "СК-Грант",
          link: "https://sk-grant.kz/",
          img: require("@/assets/img/projects/3-sk-grant.jpg"),
          year: "2018",
          descr:
            "Website layout, front-end development based on SPA with Vue.js",
        },
        {
          name: "Kopilka",
          link: "",
          img: require("@/assets/img/projects/kopilka.jpg"),
          year: "2016",
          descr:
            "Participation in the front-end development of the site & admin panel",
        },
      ],
      activeProjectIndex: 0,
    };
  },
  computed: {
    activeProject() {
      return this.projects[this.activeProjectIndex];
    },
  },
  mounted() {
    var self = this;

    var vars = {};
    vars.$window = $(window);
    vars.$body = $(document.body);
    vars.$projectsSection = $(".v2-projects");

    vars.indexPortfolioSlider = distortionSlider($(".v2-projects-slider"), {
      btnPrev: $(".v2-projects-slider__nav-btn--prev"),
      btnNext: $(".v2-projects-slider__nav-btn--next"),
      onInit: function() {
        $(".v2-projects-slider").addClass("is-inited");
      },
      onSlideChange: function(e) {
        if (self.activeProjectIndex === e) return;
        gsap
          .timeline({
            onStart: function() {
              $(".v2-projects-slider").addClass("is-animating");
            },
            onComplete: function() {
              $(".v2-projects-slider").removeClass("is-animating");
            },
          })
          .to($(".v2-projects-info"), 0.4, {
            opacity: 0,
          })
          .add(function() {
            self.activeProjectIndex = e;
          })
          .from(
            ".v2-projects-info",
            0.5,
            {
              opacity: 0,
              clearProps: "all",
            },
            "a"
          )
          .from(
            ".v2-projects-info__title",
            1,
            {
              y: -10,
            },
            "a"
          )
          .from(
            ".v2-projects-info__descr",
            1,
            {
              y: 10,
            },
            "a"
          )
          .from(
            ".v2-projects-info__title-line",
            1,
            {
              opacity: 0,
              width: 0,
            },
            0.5,
            "a"
          )
          .from(
            ".v2-projects-info__year",
            1,
            {
              opacity: 0,
              x: -10,
            },
            0.5,
            "a"
          );
      },
    });

    vars.$projectsSection.on("keydown", function(e) {
      37 === e.keyCode && vars.indexPortfolioSlider.prev(!0),
      39 === e.keyCode && vars.indexPortfolioSlider.next(!0);
    });

    vars.indexPortfolioSlider.startAutoplay();

    this.initSwipe(vars);
  },
  methods: {
    initSwipe(vars) {
      var $slider = document.querySelector(".v2-projects-slider");

      function actLeft() {
        vars.indexPortfolioSlider.prev(!0);
      }
      function actRight() {
        vars.indexPortfolioSlider.next(!0);
      }
      function actClick() {
        $slider.click();
      }

      $slider.addEventListener("touchstart", handleTouchStart, false);
      $slider.addEventListener(
        "touchmove",
        (e) => {
          handleTouchMove(e, actLeft, actRight);
        },
        false
      );

      //link tap events
      $slider.addEventListener(
        "touchend",
        (e) => {
          handleTouchEnd(e, actClick);
        },
        false
      );
    },
  },
};
</script>
